const LOCAL_PARTNER_CONNECTION_HOSTS = new Set([
  'localhost',
  '127.0.0.1',
  '[::1]',
  '::1',
]);

const currentHostname = () => {
  if (typeof window === 'undefined' || !window.location) return '';
  return window.location.hostname;
};

/**
 * The partner-connections company screen is a local development surface.
 *
 * The same frontend bundle can serve staging and production, so a build-time
 * flag alone cannot safely distinguish those deployments. Keep the local flag
 * as an opt-out for ordinary app development, but never allow it to turn the
 * screen on for a remote host.
 */
export function isPartnerConnectionsEnabled(hostname = currentHostname()) {
  const enabledForLocalDevelopment =
    String(process.env.REACT_APP_PARTNER_CONNECTIONS_ENABLED ?? 'true')
      .trim()
      .toLowerCase() === 'true';

  return (
    enabledForLocalDevelopment &&
    LOCAL_PARTNER_CONNECTION_HOSTS.has(String(hostname || '').toLowerCase())
  );
}

export const PARTNER_CONNECTIONS_ENABLED = isPartnerConnectionsEnabled();
